import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_URL_MAP_ROUTING_SERVICE,
  validateStatus: (status) => status === 200,
});

export default api;
